import React from "react";
import { NavLink, Outlet } from "react-router-dom";

const MarketingLayout = () => {
  return (
    <div className=" min-h-screen">
      {/* Mobile Navigation */}
      <div className="flex gap-2 p-2 md:hidden bg-neutral-20 rounded-xl">
        <NavLink
          to="/marketing/users"
          className={({ isActive }) =>
            `flex-1 rounded-lg py-2 text-center font-medium transition ${
              isActive ? "bg-white text-neutral-90" : "bg-neutral-20 text-neutral-40"
            }`
          }
        >
          کاربران زیر مجموعه
        </NavLink>

        <NavLink
          to="/marketing/settlements"
          className={({ isActive }) =>
            `flex-1 rounded-lg py-2 text-center font-medium transition ${
              isActive ? "bg-white text-neutral-90" : "bg-neutral-20 "
            }`
          }
        >
          تسویه های من
        </NavLink>
      </div>

      {/* Page Content */}
      <div className="p-2">
        <Outlet />
      </div>
    </div>
  );
};

export default MarketingLayout;
